module.exports = __webpack_public_path__ + "static/img/illus-thumb.ce8ba91.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-thumb.webp
// module id = 35
// module chunks = 0